<template>
<div class="agency-hero">
    <slot name="breadcrumb" />

    <agency-lead-modal />

    <div class="container agency mt-5 mb-4" id="agencymap">
        <agency-card
            :include-modal="true"
            :agency="agency"
        >
            <template slot="business_name">
                <slot name="business-name" />
            </template>

            <template slot="district">
                <slot name="district" />
            </template>

            <template slot="address">
                <slot name="address" />
            </template>

            <template slot="email">
                <modal-opener name="agency-lead" :data="agency.id">
                    <a class="email">
                        <img src="/img/icons/mail-agency.svg" />
                        {{ agency.email }}
                    </a>
                </modal-opener>
            </template>

            <template slot="phone">
                <a :href="'tel:' + agency.phone" class="phone">
                    <masked-image src="/img/icons/phone-agency.svg" :alt="agency.phone" style="width: 1rem"></masked-image>
                    {{ phoneToShow }}
                </a>
            </template>

            <template slot="links">
                <div class="links-container">
                    <slot name="links" />
                </div>
            </template>

            <template v-if="agency.team" slot="team">
                <agency-team-carousel :team="agency.team" />
            </template>
        </agency-card>

        <agency-map
            v-if="isActive"
            :latitude="agency.latitude"
            :longitude="agency.longitude"
            :network="agency.network"
            :sector="agency.sector"
            :tecnomaps-endpoint="tecnomapEndpoint"
            :marker="marker"
        />

        <div v-if="$slots.description" class="agency-card">
            <slot name="description" />
        </div>
    </div>
</div>
</template>

<script>
import AgencyCard from '../../components/agencies/Card'
import AgencyLeadModal from '../../components/agencies/LeadModal'
import AgencyMap from '../../components/agencies/Map'
import AgencyTeamCarousel from '../../components/agencies/TeamCarousel'
import ModalOpener from '../../components/ModalOpener'

export default {
    components: {
        'agency-card': AgencyCard,
        'agency-lead-modal': AgencyLeadModal,
        'agency-map': AgencyMap,
        'agency-team-carousel': AgencyTeamCarousel,
        'modal-opener': ModalOpener,
    },

    props: {
        agency: {
            type: Object,
            required: true,
        },

        config: {
            type: Object,
            required: true,
        },

        marker: {
            type: String,
            required: true,
        },

        tecnomapEndpoint: {
            type: String,
            required: true,
        },
    },

    computed: {
        isActive() {
            let allowed_statuses = ['ATTIVO', 'PRE_SOSPESO']

            return allowed_statuses.includes(this.agency.status)
        },

        phoneToShow() {
            return this.isActive ? this.agency.phone : (this.agency.phone_real ?? this.agency.phone)
        },
    },
}
</script>